// extracted by mini-css-extract-plugin
export default {"backLink":"AddPermit_backLink__EnG5n","dateTime":"AddPermit_dateTime__ZvfG3","radio":"AddPermit_radio__PJK8G","col":"AddPermit_col__F3AFt"};